// Calendar Integration Configuration
// Toggle between simulated and real calendar APIs

const webGoogleClientId =
  typeof process !== 'undefined' && process.env.REACT_APP_GOOGLE_CALENDAR_CLIENT_ID
    ? process.env.REACT_APP_GOOGLE_CALENDAR_CLIENT_ID
    : '82811648963-8hnf2ia4del03sr3k3pc6rgmnmrd3ngh.apps.googleusercontent.com';

export const CALENDAR_CONFIG = {
  // Set to true to use real calendar APIs (Google, Outlook, Apple)
  // Set to false to use simulated calendar integration (for testing)
  USE_REAL_CALENDAR_API: true,
  
  // Google Calendar Configuration
  GOOGLE: {
    // IMPORTANT: Replace with your actual Google OAuth Client ID
    // Get from: https://console.cloud.google.com/apis/credentials
    // Web OAuth uses Firebase Google sign-in (see realCalendarIntegrationService).
    // Native apps use this client + custom scheme redirect.
    CLIENT_ID: webGoogleClientId,
    
    REDIRECT_URI: 'com.bookapt://oauth',
    /** Web OAuth callback is handled by backend — register in Google Console:
     *  http://localhost:4001/api/calendar/google/callback
     *  https://YOUR-API-HOST/api/calendar/google/callback
     */
    WEB_REDIRECT_URI: 'http://localhost:4001/api/calendar/google/callback',
    SCOPES: [
      'https://www.googleapis.com/auth/calendar',
      'https://www.googleapis.com/auth/calendar.events'
    ],
    API_URL: 'https://www.googleapis.com/calendar/v3',
  },
  
  // Microsoft Outlook Configuration
  MICROSOFT: {
    // IMPORTANT: Replace with your actual Microsoft Application (Client) ID
    // Get from: https://portal.azure.com/ > Azure Active Directory > App registrations
    CLIENT_ID: 'YOUR_MICROSOFT_CLIENT_ID',
    
    REDIRECT_URI: 'com.bookapt://oauth',
    SCOPES: [
      'Calendars.ReadWrite',
      'Calendars.ReadWrite.Shared',
      'offline_access'
    ],
    API_URL: 'https://graph.microsoft.com/v1.0',
    AUTH_URL: 'https://login.microsoftonline.com/common/oauth2/v2.0',
  },
  
  // Apple Calendar Configuration (iOS native - no setup required)
  APPLE: {
    ENABLED: true, // Apple Calendar uses native iOS EventKit
  },
  
  // Feature Flags
  FEATURES: {
    AUTO_SYNC: true,              // Automatically sync confirmed bookings
    RECURRING_EVENTS: true,       // Support recurring appointments
    REMINDERS: true,              // Add event reminders
    DEFAULT_REMINDERS: [60, 15],  // Reminder minutes before event [1 hour, 15 min]
  },
};

export default CALENDAR_CONFIG;



